const state = {
  showLeftMenu: false,
  menus: [],
  rules: [],
  users: {},
  userGroups: [],
  organizes: [],
  menusList: [],
  menusThreeList: [],
  menusUpdate: false,
  isUnRead: false,
  isSetLog: false,
  isImportDialogUpdate: false,
  isImportDialogClose: false,
  contentFailIds: {}, // 用于临时记录功能集列表里操作失败的列表项
  importConfigData: [],
  documentTitle: ''
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/state.js